import { useEffect, useRef } from "react";

/**
 * ? Hook to abort state update when component is unmount
 * * fix error "can't perform a react state update" without fetch
 * @returns callback
 */
export function useMounted() {
  const isMounted = useRef<boolean>(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
}
